import { Percent, mkPercent } from './percent'
import { Outcome } from './outcome'
import { Result, __Result } from './result'
import { MultiLocaleString } from './multi-locale-string'

// ----------------------------------------------------------------------------
// BallotState
//
// Percent here is the percent of 'Yea' votes. That means, when >50% the ballot
// is projected or was accepted. The 'at' Date is the time when the trend or
// projection was last updated. Only use the time portion of the Date value,
// ignore the year/month/day.

export type BallotState =
  | 'pre'
  | 'in-progress'
  | { trend: Outcome; at: undefined | string }
  | { projection: Percent; detail: MultiLocaleString }
  | { finalResult: Result }

export const mkBallotState = (x: BallotState): BallotState => x

export interface BallotStateMatcher<T> {
  pre: T
  inProgress: T
  trend(_: { trend: Outcome; at: undefined | string }): T
  projection(_: { projection: Percent; detail: MultiLocaleString }): T
  finalResult(_: { finalResult: Result }): T
}

export const caseBallotState =
  <T>(m: BallotStateMatcher<T>) =>
  (bs: BallotState): T => {
    if (bs === 'pre') {
      return m.pre
    } else if (bs === 'in-progress') {
      return m.inProgress
    } else if ('trend' in bs) {
      return m.trend(bs)
    } else if ('projection' in bs) {
      return m.projection(bs)
    } else if ('finalResult' in bs) {
      return m.finalResult(bs)
    } else {
      return bs
    }
  }

// ----------------------------------------------------------------------------
// Catalog

export const __BallotState = {
  pre: mkBallotState('pre'),
  inProgress: mkBallotState('in-progress'),
  trend: {
    yea: mkBallotState({ trend: 'yea', at: '12:45' }),
    nay: mkBallotState({ trend: 'nay', at: '13:15' }),
  },
  projection: {
    yea: mkBallotState({ projection: mkPercent(0.651), detail: {} }),
    nay: mkBallotState({ projection: mkPercent(0.251), detail: {} }),
  },
  finalResult: {
    yea: mkBallotState({ finalResult: __Result.yea }),
    yeaWithGap: mkBallotState({ finalResult: __Result.yeaWithGap }),
    nay: mkBallotState({ finalResult: __Result.nay }),
  },
}
